import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { UserConfigurationService } from '../../core/services/user-configuration.service';
import { DimensionSystem } from '../enums/dimension-system.enum';
import { RemainingValueType } from '../enums/remaining-value-type.enum';

@Pipe({
  name: 'remainingValueType',
  standalone: true,
})
export class RemainingValueTypePipe implements PipeTransform {
  constructor(
    private languageService: LanguageService,
    private userConfigurationService: UserConfigurationService,
  ) {}

  transform(valueType: RemainingValueType, value?: number): string {
    const isSingular = value === 1;
    const metric = isSingular
      ? this.translate('general.units.distance.km.s')
      : this.translate('general.units.distance.km.pl');
    const imperial = isSingular
      ? this.translate('general.units.distance.mi.s')
      : this.translate('general.units.distance.mi.pl');

    switch (valueType) {
      case RemainingValueType.DAYS:
        return isSingular ? this.translate('general.units.time.day.s') : this.translate('general.units.time.day.maintenance.pl');
      case RemainingValueType.MILEAGE:
        return this.isMetricSystem() ? metric : imperial;
      case RemainingValueType.OPERATING_HOURS:
        return isSingular ? this.translate('general.operatingHour.s') : this.translate('general.operatingHour.pl');
      default:
        return '';
    }
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }

  private isMetricSystem(): boolean {
    return this.userConfigurationService.getUserDimensionSystem() === DimensionSystem.METRIC;
  }
}
